import React from 'react'
import PropTypes from 'prop-types'
import { Input, Empty } from 'antd'
import {
  ajaxApi
} from '../../../server/index'
import { qwWxShareFn } from '../utils'
import classnames from 'classnames'
import styles from './ActivityTabItem.module.less'
import common from '../../../public/common'
import moment from 'moment'
moment.locale('zh-cn')
const { Search } = Input

class ActivityTabItem extends React.Component {
  state = {
    sqParam: {
      'page_size': 10,
      'page_index': 1,
      'activity_type': 'BRANDWX',
      'activity_topic': '',
      'from_side_bar': true,
      'open': true,
      'status': 'INPROGRESS'
    },
    sqDataList: [],
    sqLoadingState: true,
    ptParam: {
      'page_size': 10,
      'page_index': 1,
      'activity_type': 'PLATFORM',
      'activity_topic': '',
      'from_side_bar': true,
      'open': true,
      'status': 'INPROGRESS'
    },
    ptDataList: [],
    ptLoadingState: true
  }

  componentDidMount() {
    this.init()
  }
  
  // 初始化列表
  init = async () => {
    this.initSQList()
    this.initPTList()
  }

  // 社群列表
  initSQList = async () => {
    try {
      const { sqParam } = this.state
      let env = process.env.REACT_APP_ENV
      let url = 'https://gw-admin.vsigo.cn/webadmin/'
      if (env !== 'production') {
        url = 'https://gw-admin-t.vsigo.cn/webadmin/'
      }
      const res = await ajaxApi(`${url}sidebar/activity-config-list`, {
        ...sqParam,
        brandwx_brand_id: this.props.brandId,
      })
      if (res.status === 200) {
        const list = res.data.data || []
        this.setState({
          sqDataList: list,
          sqLoadingState: list.lengh < 10,
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  // 平台列表
  initPTList = async () => {
    try {
      const { ptParam } = this.state
      let env = process.env.REACT_APP_ENV
      let url = 'https://gw-admin.vsigo.cn/webadmin/'
      if (env !== 'production') {
        url = 'https://gw-admin-t.vsigo.cn/webadmin/'
      }
      const res = await ajaxApi(`${url}sidebar/activity-config-list`, ptParam)
      if (res.status === 200) {
        const list = res.data.data || []
        this.setState({
          ptDataList: list,
          ptLoadingState: list.lengh < 10,
        })
      }
    } catch (error) {
      console.log(error)
    }
  }

  // 筛选输入框
  onPressEnter = (e) => {
    let { sqParam, ptParam } = this.state
    let activityTopic = e.target.value
    sqParam.page_index = 1
    sqParam.activity_topic = activityTopic.trim()
    ptParam.page_index = 1
    ptParam.activity_topic = activityTopic.trim()
    this.setState({
      sqParam,
      ptParam
    }, () => {
      this.init()
    })
  }

  // 搜索
  onSearch = (v) => {
    let { sqParam, ptParam } = this.state
    sqParam.activity_topic = v.trim()
    ptParam.activity_topic = v.trim()
    sqParam.page_index = 1
    ptParam.page_index = 1
    this.setState({
      sqParam,
      ptParam
    }, () => {
      this.init()
    })
  }

  onClickMoreBtnSQ = () => {
    let { sqParam } = this.state
    sqParam.page_index += 1
    this.setState({
      sqParam,
    }, () => {
      this.initSQList()
    })
  }

  onClickMoreBtnPT = () => {
    let { ptParam } = this.state
    ptParam.page_index += 1
    this.setState({
      ptParam
    }, () => {
      this.initPTList()
    })
  }

  onSendActivityCard = (item) => {
    qwWxShareFn({
      title: item.activity_topic,
      imgUrl: item.activity_img,
      link: '/pages/H5zhuanti/H5zhuanti.html?pageUrl=' + encodeURIComponent(item.activity_url),
      brandName: this.props.brandName,
      webUrl: item.activity_url
    })
  }

  renderActivityCard = (item) => {
    return <div className={styles.ActivityTabItem}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span className={classnames([styles.activityName])}>{item.activity_topic}</span>
        <div>
          <span>{moment(item.begin_time).format('YYYY-MM-DD')}</span>
          {item.end_time ? <span>{` - ${moment(item.end_time).format('YYYY-MM-DD')}`}</span> : null}
        </div>
      </div>
      <div className={styles.contents}>
        <div className={styles.imgWrap}>
          <img className={styles.imgWrap} src={item.activity_img}></img>
        </div>
        <div className={styles.rightContent}>
          <div>
            <span>活动说明：</span>
            <span className={styles.desTitle}>{item.activity_desc || ''}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'right' }}>
            <div className={classnames([styles.sendBtn])} onClick={() => this.onSendActivityCard(item)}>发送</div>
          </div>
        </div>
      </div>
    </div>
  }

  render() {
    const { sqDataList, ptDataList, sqLoadingState, ptLoadingState } = this.state
    return (
      <div className={classnames([styles.activityContent])}>
        <div className={classnames([styles.flexBetweenRow, styles.marginBottom8])} style={{ alignItems: 'baseline' }}>
          <Search placeholder='输入活动名称' allowClear onSearch={this.onSearch}></Search>
        </div>
        {this.props.isWxwork ? <div className={classnames([styles.marginBottom8])}>
          <div className={classnames([styles.tabName])}>品牌社群</div>
          {
            sqDataList.map((item, i) => this.renderActivityCard(item, i))
          }
          {sqDataList && sqDataList.length > 0 ? (
            sqLoadingState ? <div className={classnames([styles.loadingBtn])} onClick={this.onClickMoreBtnSQ}>查看更多</div> :
              <div className={classnames([styles.noMoreData])} >没有更多了</div>
          ) : <Empty />}
        </div> : null}
        <div className={classnames([styles.marginBottom8])}>
          <div className={classnames([styles.tabName])}>平台</div>
          {
            ptDataList.map((item, i) => this.renderActivityCard(item, i))
          }
          {ptDataList && ptDataList.length > 0 ? (
            ptLoadingState ? <div className={classnames([styles.loadingBtn])} onClick={this.onClickMoreBtnSQ}>查看更多</div> :
              <div className={classnames([styles.noMoreData])} >没有更多了</div>
          ) : <Empty />}
        </div>
      </div>
    )
  }
}

ActivityTabItem.propTypes = {
  isWxwork: PropTypes.bool,
  brandName: PropTypes.string,
  brandId: PropTypes.string
}

export default ActivityTabItem



// WEBPACK FOOTER //
// ./src/pages/udeskSide/components/ActivityTabItem.js